export default __webpack_public_path__ + "static/media/mock test.b49cddf8.svg";